import { render, staticRenderFns } from "./kitPage.vue?vue&type=template&id=67e0868f&scoped=true&"
import script from "./kitPage.vue?vue&type=script&lang=js&"
export * from "./kitPage.vue?vue&type=script&lang=js&"
import style0 from "./kitPage.vue?vue&type=style&index=0&id=67e0868f&prod&scoped=true&lang=stylus&"
import style1 from "./kitPage.vue?vue&type=style&index=1&id=67e0868f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0868f",
  null
  
)

export default component.exports